import React, { createContext, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";
import { apiClient } from "../api/apiServices";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("access_token"));
  const [user, setUser] = useState(null);        // This will hold the FULL user object
  const [loading, setLoading] = useState(true);

  // Improved login function that accepts both token AND user data
  const handleLogin = (token, userData = null) => {
    setToken(token);
    localStorage.setItem("access_token", token);
    apiClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    if (userData) {
      // Prefer full user data from backend
      setUser(userData);
    } else {
      // Fallback: decode from token
      try {
        const decoded = jwtDecode(token);
        setUser(decoded);
      } catch (err) {
        console.error("Failed to decode token:", err);
      }
    }
    return userData || jwtDecode(token);
  };

  const handleLogout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem("access_token");
    delete apiClient.defaults.headers.common["Authorization"];
  };

  // Load user from localStorage on app start
  useEffect(() => {
    const existingToken = localStorage.getItem("access_token");
    if (!existingToken) {
      setLoading(false);
      return;
    }

    try {
      const decoded = jwtDecode(existingToken);

      if (decoded.exp * 1000 < Date.now()) {
        handleLogout();
        toast.info("Session expired. Please login again.");
      } else {
        setToken(existingToken);
        // Note: We can't restore full user object from token only
        // So we keep decoded token as fallback
        setUser(decoded);
        apiClient.defaults.headers.common["Authorization"] = `Bearer ${existingToken}`;
      }
    } catch (err) {
      console.error("Invalid token:", err);
      handleLogout();
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{
        token,
        user,
        isAuthenticated: !!user && !!token,
        loading,
        login: handleLogin,
        logout: handleLogout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};